import React, { useContext, useEffect, useState } from 'react';
import { Context } from '@routes/private/Editor/Context';
import { IProps } from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import ToolTip from '@components/Tooltip';

const ReplaceImageCommandOption: React.FC<IProps> = () => {

  let context = useContext(Context);

  const SetPicker = () => {
    const picker = (context.editorStatus.currentPicker === "ReplaceImage") ? undefined : "ReplaceImage";
    context.onShowPicker(picker);
  }

  return (
    <S.Root>
      <ToolTip
        tip="Replace Image"
      >
        <S.ButtonContainer onClick={() => { SetPicker() }} backgroundColorValue={context.editorStatus.currentPicker === "ReplaceImage" ? C.DARK_BLUE : 'auto'}>
          Replace Image
        </S.ButtonContainer>
      </ToolTip>
    </S.Root>
  );
}

export default ReplaceImageCommandOption;